// Uppdragsbudgetens format och ren logik för budgetrutnätet.
//
// Nuvarande format: projects/{id}.budgets = [{ id, name, startMonth, endMonth,
// resources, activities: [{ id, name, resourceLines: [{ id, resourceId, months }] }],
// licenses }]. Timmarna ligger på aktivitetsraderna (resourceLines).
//
// Gamla format, som konverteras med scripts/konvertera-budgetformat.js:
//   - budgetResources/budgetActivities direkt på projektet, utan budgets
//   - aktiviteter med en person: { id, name, resourceId, months } utan resourceLines
// Budgetfliken visar gamla format skrivskyddat tills de konverterats.

export function harGammaltBudgetformat(projekt) {
  if (!projekt) return false;
  const budgetar = Array.isArray(projekt.budgets) ? projekt.budgets : [];
  if (!budgetar.length) return !!(projekt.budgetResources?.length || projekt.budgetActivities?.length);
  return budgetar.some(b => (b.activities || []).some(a => !Array.isArray(a.resourceLines)));
}

/**
 * Kopierar månaden `fran` till `till` på alla aktivitetsrader (drag från en
 * månadsrubrik till en annan). Tomt värde blir 0.
 */
export function kopieraManad(aktiviteter, fran, till) {
  return (aktiviteter || []).map(a => ({
    ...a,
    resourceLines: (a.resourceLines || []).map(l => ({
      ...l,
      months: { ...l.months, [till]: l.months?.[fran] || 0 },
    })),
  }));
}
